export const userInputs = [
    {
      id: "username",
      label: "Username",
      type: "text",
      placeholder: "john_doe",
    },
    {
      id: "displayName",
      label: "Name and surname",
      type: "text",
      placeholder: "John Doe",
    },
    {
      id: "email",
      label: "Email",
      type: "mail",
      placeholder: "john_doe@gmail.com",
    },
    {
      id: "phone",
      label: "Phone",
      type: "text",
      placeholder: "+1 234 567 89",
    },
    {
      id: "password",
      label: "Password",
      type: "password",
    },
    {
      id: "address",
      label: "Address",
      type: "text",
      placeholder: "Elton St. 216 NewYork",
    },
    {
      id: "country",
      label: "Country",
      type: "text",
      placeholder: "USA",
    },
  ];
  
  export const productInputs = [

    {
      id: "name",
      label: "Nombre",
      type: "text",
      placeholder: "Nombre de la empresa",
    },
    {
      id: "description",
      label: "Descripción",
      type: "text",
      placeholder: "Descripción de la empresa",
    },
    {
      id: "categoria",
      label: "Categoria",
      type: "text",
      placeholder: "empresa o restaurante",
    },
    {
      id: "email",
      label: "Correo",
      type: "email",
      placeholder: "Correo electrónico",
    },
    {
      id: "contactName",
      label: "Nombre del Encargado",
      type: "text",
      placeholder: "Nombre del Encargado",
    },
    {
      id: "phoneNumber",
      label: "Número de celular",
      type: "tel",
      placeholder: "Número de celular",
    },
  ];

  export const sliderInputs = [

    {
      id: "name",
      label: "Nombre",
      type: "text",
      placeholder: "Nombre de la imagen",
    },
  ];

  export const menuInputs = [

    {
      id: "name",
      label: "Nombre",
      type: "text",
      placeholder: "Nombre del platillo",
    },
    {
      id: "description",
      label: "Descripción",
      type: "text",
      placeholder: "Descripción del platillo",
    },
    {
      id: "precio",
      label: "Precio",
      type: "number",
      placeholder: "Precio del platillo",
    },
    // {
    //   id: "categoria",
    //   label: "categoria",
    //   type: "select",
    //   options: ["Crepas y waffles", "Bebidas", "Comida", "Almuerzos"],
    //   placeholder: "Selecciona la categoría",
    //  // Esto indica que se permitirá la selección múltiple
    // }
  ];